function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("circle", {
  cx: 8,
  cy: 8,
  r: 8,
  fill: "#757D9F"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M7.194 10.398c.008-.504.065-.902.171-1.194.106-.292.322-.616.648-.971l.831-.857c.356-.402.533-.834.533-1.295 0-.444-.116-.791-.349-1.041-.232-.254-.571-.38-1.015-.38-.432 0-.779.113-1.041.342-.263.228-.394.535-.394.92H5.404c.008-.685.252-1.237.73-1.656.482-.424 1.109-.635 1.879-.635.8 0 1.422.216 1.866.647.449.428.673 1.016.673 1.765 0 .74-.343 1.47-1.029 2.19l-.691.685c-.31.343-.464.836-.464 1.48H7.194zm-.05 2.012c0-.19.056-.35.17-.476.119-.132.292-.197.521-.197.228 0 .402.065.52.197a.67.67 0 0 1 .178.476c0 .19-.059.349-.178.476-.118.123-.292.184-.52.184-.229 0-.402-.062-.52-.184a.685.685 0 0 1-.172-.476z",
  fill: "#F2F6FA"
});

const SvgInfoCircle = props => React.createElement("svg", _extends({
  width: 16,
  height: 16,
  fill: "none"
}, props), _ref, _ref2);

export default SvgInfoCircle;